var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04923 10.9496C0.811433 10.7118 0.784189 10.346 0.972729 10.0953L1.0295 10.0299L10.0289 1.03052C10.2774 0.782011 10.6892 0.790844 10.9486 1.05024C11.1864 1.28804 11.2136 1.65387 11.0251 1.90458L10.9683 1.96992L1.9689 10.9693C1.72039 11.2179 1.30863 11.209 1.04923 10.9496Z",
    fill: "#1C4C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11144 2.00732C2.75231 2.00038 2.45432 1.70358 2.4458 1.34445C2.4381 1.01792 2.67232 0.752261 2.98481 0.71185L3.08075 0.706639L10.4831 0.849484C10.8106 0.855835 11.0871 1.10304 11.1399 1.41861L11.1488 1.51514L11.2923 8.91817C11.2993 9.27732 11.0138 9.56155 10.6546 9.55311C10.3281 9.54544 10.0531 9.29851 10.0006 8.9838L9.99169 8.88758L9.86043 2.13754L3.11144 2.00732Z",
    fill: "#1C4C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.667ea62f.svg";
export { ForwardRef as ReactComponent };